<template>
<div class="mainWrap" :class="[systemClassName]">
    <header>
        <div class="container">
                <div class="columns is-desktop is-centered">
                <div class="column is-8 has-text-centered">
        <nav class="navbar" role="navigation" aria-label="main navigation">
            <div class="navbar-brand">
                    <a class="navbar-item"> <router-link to="/home"><img class="logo" src="./assets/img/tz_logo_red_slogan_final.png" height="28"></router-link></a>

                    <a role="button" id="navbar-burger" class="navbar-burger burger" v-bind:class="{'is-active':isActive}" aria-label="menu" aria-expanded="false" data-target="navbarBasic" @click="toogleMobile()">
                        <span aria-hidden="true"></span>
                        <span aria-hidden="true"></span>
                        <span aria-hidden="true"></span>
                    </a>
            </div>


            <div id="navbarBasic" class="navbar-menu" v-bind:class="{'is-active':isActive}">
                <div class="navbar-start">
                    <a :href="info.url"    :target="info.target"    class="navbar-item">{{ $t("info-menu") }}</a>
                    <a :href="contact.url" :target="contact.target" class="navbar-item">{{ $t("contact-menu") }}</a>
                    <a :href="about.url"   :target="about.target"   class="navbar-item">{{ $t("about-us") }}</a>
                    <a v-if="getUserTokenState" class="navbar-item">
                        <router-link :to="{ name : 'companies', params : {cid : getCompany }}">
                        {{ $t("admin") }}
                        </router-link>
                    </a>
                </div>

                <div class="navbar-end">
                    <div class="navbar-item">
                        <a @click="switchLanguage('en')">{{ $t("english") }} </a>
                        <span style="padding-left:5px;"> </span> | <span style="padding-left:5px;"> </span>
                        <a @click="switchLanguage('de')"> {{ $t("german") }}</a>
                    </div>
                    <div class="navbar-item">
                        <div class="buttons" v-if="!getUserTokenState">
                            <a class="button is-light">
                            <router-link to="/register">{{ $t("register") }}</router-link>
                            </a>
                        </div>
                    <div class="navbar-item has-dropdown is-hoverable" v-if="getUserTokenState">
                        <a class="navbar-link">
                            {{getUserUsername}}
                        </a>
                    <div class="navbar-dropdown">
                        <a class="navbar-item">
                            <router-link :to="{name: 'Logout'}">{{ $t ("logout") }}</router-link>
                        </a>
                    </div>
                    </div>
                    </div>
                </div>
            </div>
        </nav>
        </div>
        </div>
        </div>
    </header>
    <router-view></router-view>
<footer>
<section class="section big-footer" style="background-color:#2d2d2d;">
    <div class="container">
        <div class="columns">
            <div class="column has-text-centered">
            <p>{{ copyright }}</p>
            <p v-html="slogan"></p><br>
            <p style="font-size:11px;">v.{{ version }}</p>
            </div>
        </div>
    </div>
</section>
</footer>
</div>
</template>


<script>
import BaseApp from '@/BaseApp'
import config  from "../config"

export default {
    name: 'App',
    extends: BaseApp,
    data () {
        const systemClassName = `${config.cssClass}-system`
        const aboutUrl        = config.aboutUrl   || "https://www.tzaustria.com/de/ueber-uns/"
        const contactUrl      = config.contactUrl || "/home#kontakt"
        const infoUrl         = config.infoUrl    || "/home#info"
        const linkTarget = function (url) {
            let target = "_self"
            if (url.indexOf ("#") == -1) target = "_blank"
            return {url, target}
        }
        return {
            systemClassName,
            about   : linkTarget (aboutUrl),
            contact : linkTarget (contactUrl),
            info    : linkTarget (infoUrl),
            copyright : config.copyright || "(c) 2019-2020 - TZ Tischlerzentrum GesmbH",
            slogan    : config.slogan    || "Your FUTURE<br>IN INNOVATION"
        }
    }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Fjalla+One|Karla');

.test-system {
    background-color: lightblue;
}

.stage-system, .dev-system {
    background-color: lightyellow;
}

.live-system {
    background-color: #bdbaba;
}

h1,h2,h3{
    font-family: 'Fjalla One' !important;
    font-weight:bold;
}

h1{
    font-size:37px!important;
    margin-bottom:26px!important;
}

h2{
    font-size:22px!important;
    margin-bottom:20px!important;
    color:#a72523!important;
}

body{
    font-family: 'Karla', sans-serif !important;
    font-size:14px;
    color:#444!important;
}

*{
  margin: 0;
  padding: 0;
}

.steps{
    margin-top:55px;
    margin-bottom:55px;
}

a{
    color:#a72523 !important;
}
a.is-link {
    color:whitesmoke !important;
}

h1{
    color:#a72523!important;

}

.is-primary {
    background-color: #a72523 !important;
}

.is-primary a{
    color:#fff!important;
}

.navbar-link:not(.is-arrowless)::after {
    border-color:#a72523!important;
}

.is-primary{
    color:#fff!important;
}
.pagination-link.is-current  {
    background-color: #a72523 !important;
    color:#fff!important;
}

.small-footer .container{
    border-top: 1px solid #cccccc;
    padding-top: 20px;
    padding-bottom: 20px;
}

.big-footer{
    margin-bottom:40px!important;
}

.hero-body .title{
    color:#fff!important;
}

.hero-body .subtitle{
    color:#fff!important;
}

  input:focus{
    border-color:#a72523!important;
  }

  input:hover{
    border-color:#a72523!important;
  }

  .select:not(.is-multiple):not(.is-loading)::after {
    border-color: #a72523!important;
}

  .b-radio.radio input[type=radio] + .check:before{
    background:#a72523!important;
  }

  .b-radio.radio input[type=radio]:checked + .check {
    border-color: #a72523!important;
}

.b-checkbox.checkbox input[type=checkbox]:checked + .check{
    background-color: #a72523!important;
    border-color:#a72523!important;
  }

  .big-footer p{
    color:#9d9d9d;
  }
</style>